<div>
  <form method="post" enctype="multipart/form-data">
    <input id='imageUploadInput' #inp style="display:none;" type="file" (change)="fileChange($event)" placeholder="Upload file" />
  </form>

  <ch-image-view (onClick)="triggerUpload()" [resourceId]="resourceId"></ch-image-view>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/image-upload/image-upload.component.html